import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Paper, Link, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: { xs: 2, md: 3 },
        background: 'linear-gradient(135deg, rgba(20,36,95,0.95) 0%, rgba(26,35,126,0.92) 100%)',
        backdropFilter: 'blur(12px)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        boxShadow: '0 -8px 32px rgba(0,0,0,0.2)',
      }}
    >
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, md: 3 },
            borderRadius: 3,
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.08)',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Typography
            sx={{
              color: 'rgba(255,255,255,0.9)',
              fontSize: { xs: 13, md: 14 },
              lineHeight: 1.6,
              flex: 1,
            }}
          >
            Мы используем файлы cookie. К нашему сайту подключен сервис веб-аналитики
            Яндекс Метрика, использующий cookie — небольшие текстовые файлы,
            размещаемые на вашем компьютере с целью анализа пользовательской активности.
            Вы даете свое согласие на обработку персональных данных с помощью этого сервиса
            в порядке, указанном в{' '}
            <Link
              component={RouterLink}
              to="/privacy"
              sx={{
                color: '#ffd700',
                fontWeight: 600,
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Политике конфиденциальности
            </Link>
            ?
          </Typography>

          <Box sx={{ display: 'flex', gap: 1.5, flexShrink: 0 }}>
            <Button
              variant="contained"
              onClick={handleAccept}
              sx={{
                borderRadius: 999,
                px: 3,
                py: 1,
                textTransform: 'none',
                fontWeight: 700,
                fontSize: 14,
                background: 'linear-gradient(135deg, #ffd700 0%, #f5c400 100%)',
                color: '#14245f',
                boxShadow: '0 8px 20px rgba(255,215,0,0.25)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #f5c400 0%, #e6b800 100%)',
                },
              }}
            >
              Согласен
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default CookieConsent;